import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Select,
  MenuItem,
  CardMedia,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import OpenGraphInfo from "@components/OpenGraphInfo";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import Title from "../../components/Title";
import Layout from "../../Layout";
import AddComCon from "../posts/AddComCon";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "../../MyAxios";
import {
  addToGroups,
  addAllToGroups,
  addAllToConnections,
  addAllToPostCommunities,
  addToPostCommunities,
  setIsGroupOnlyPost,
  resetPost,
  setDescription,
  setFile,
  setFileName,
  setMedia,
  getLinkMetadata,
  clearConnections,
} from "../../redux/postSlice";
import { addToPosts, updatePost } from "@redux/prevPostsSlice";
import { ROOT } from "../../constants/api";
import {
  GET_GROUP,
  UPLOAD_FILE,
  // CHECK_GROUP_DISABLED_FOR_EVENTS,
} from "../../constants/api";
import PostTypeTabs from "../../components/PostTypeTabs.js";
import upload from "../../assets/img/upload.svg";
import { MentionsInput, Mention } from "react-mentions";
import mentionStyle from "../posts/mentionStyles";
import mentionsInputStyle from "../posts/mentionsInputStyles";
import MyAvatar from "@components/admin/MyAvatar";
import EmojiSelector from "@components/emoji-selector/EmojiSelector";
import { formatDateTime } from "@helpers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import validator from "validator";
import locationOptions from "../../constants/locationOptions";

const GOOGLE_MAPS_API_KEY = "AIzaSyBKb_ZbMgS5gYEbGkbQgxqYDpUIcjIYhWA";
const COUNTRY_CODES = [
  { value: "US", label: "United States" },
  { value: "PK", label: "Pakistan" },
  { value: "CA", label: "Canada" },
  { value: "GB", label: "United Kingdom" },
  { value: "AU", label: "Australia" },
  { value: "IN", label: "India" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "IT", label: "Italy" },
  { value: "ES", label: "Spain" },
  { value: "NL", label: "Netherlands" },
  { value: "BE", label: "Belgium" },
  { value: "CH", label: "Switzerland" },
  { value: "AT", label: "Austria" },
  { value: "SE", label: "Sweden" },
  { value: "NO", label: "Norway" },
  { value: "DK", label: "Denmark" },
  { value: "FI", label: "Finland" },
  { value: "IE", label: "Ireland" },
  { value: "NZ", label: "New Zealand" },
  { value: "SG", label: "Singapore" },
  { value: "MY", label: "Malaysia" },
  { value: "ID", label: "Indonesia" },
  { value: "TH", label: "Thailand" },
  { value: "JP", label: "Japan" },
  { value: "KR", label: "South Korea" },
  { value: "CN", label: "China" },
  { value: "BR", label: "Brazil" },
  { value: "MX", label: "Mexico" },
  { value: "ZA", label: "South Africa" },
  { value: "NG", label: "Nigeria" },
  { value: "EG", label: "Egypt" },
  { value: "TR", label: "Turkey" },
].sort((a, b) => a.label.localeCompare(b.label));


const useStyles = makeStyles((theme) => ({
  colorGreen: { backgroundColor: "#e5f8f1" },
  bgGrey: { backgroundColor: "#efefef" },
  border: { borderWidth: 2, borderColor: "#887E7E" },
  borderGreen: { borderWidth: 1, borderColor: "#51CDA0" },
  input: { borderRadius: 4, padding: 12 },
  button: { backgroundColor: theme.palette.primary.main, color: "#fff" },
  mentionsError: {
    "& > div:first-child": {
      borderColor: "#d32f2f !important",
      borderWidth: "1px !important",
      borderStyle: "solid !important",
      borderRadius: "4px !important",
    },
    "& > div + div": {
      border: "none !important",
    },
  },
}));
const extractUrl = (text) => {
  if (!text) return null;
  let t = String(text).trim();
  try {
    t = decodeURIComponent(t);
  } catch (e) { }
  t = t.replace(/^<|>$/g, "");
  const httpRegex = /https?:\/\/[^\s<>'")]+/i;
  const wwwRegex = /www\.[^\s<>'")]+/i;
  const domainRegex =
    /(?:https?:\/\/)?(?:www\.)?[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+(?:\/[^\s<>'"]*)?/i;
  let match = t.match(httpRegex) || t.match(wwwRegex) || t.match(domainRegex);
  if (!match) return null;
  let link = match[0];
  link = link.replace(/[.,;:!?')\]]+$/g, "");
  if (!/^https?:\/\//i.test(link)) link = "https://" + link;
  try {
    return new URL(link).toString();
  } catch (e) {
    return null;
  }
};

const extractDate = (isoString) => {
  if (!isoString) return "";
  try {
    return dayjs(isoString).format("YYYY-MM-DD");
  } catch (e) {
    return "";
  }
};

const extractTime = (isoString) => {
  if (!isoString) return "";
  try {
    return dayjs(isoString).format("HH:mm");
  } catch (e) {
    return "";
  }
};

const parseMetadata = (raw) => {
  if (!raw) return null;
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const extractCoordsFromMapsLink = (url) => {
  if (!url) return null;
  try {
    new URL(url);
    if (/maps\.app\.goo\.gl/i.test(url)) {
      const pathMatch = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
      if (pathMatch)
        return { lat: parseFloat(pathMatch[1]), lng: parseFloat(pathMatch[2]) };
    }
    if (/google\.com\/maps/i.test(url)) {
      const coordsMatch = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
      if (coordsMatch)
        return {
          lat: parseFloat(coordsMatch[1]),
          lng: parseFloat(coordsMatch[2]),
        };
    }
  } catch (e) { }
  return null;
};

const loadGoogleMapsScript = (() => {
  let promise = null;
  return (apiKey) => {
    if (!apiKey) return Promise.resolve(false);
    if (window.google?.maps?.places) return Promise.resolve(true);
    if (promise) return promise;
    promise = new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => {
        promise = null;
        resolve(false);
      };
      document.head.appendChild(script);
    });
    return promise;
  };
})();

const LocationField = ({
  value,
  onChange,
  onPlaceSelect,
  locationType,
  resolvedAddress,
  error,
}) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [placesReady, setPlacesReady] = useState(false);
  const [gecodingAddress, setGeocodingAddress] = useState(false);

  useEffect(() => {
    loadGoogleMapsScript(GOOGLE_MAPS_API_KEY).then((ok) => setPlacesReady(ok));
  }, []);

  useEffect(() => {
    if (!value || locationType !== "In-person" || !placesReady) return;
    const detectedLink = extractUrl(value);
    if (!detectedLink) return;
    const isMapsLink = /google\.com\/maps|maps\.app\.goo\.gl/i.test(
      detectedLink,
    );
    if (!isMapsLink) return;
    const coords = extractCoordsFromMapsLink(detectedLink);
    if (!coords) return;
    setGeocodingAddress(true);
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: coords }, (results, status) => {
      setGeocodingAddress(false);
      if (status === "OK" && results && results[0]) {
        const formattedAddress = results[0].formatted_address;
        onPlaceSelect({ formattedAddress, lat: coords.lat, lng: coords.lng });
      }
    });
  }, [value, locationType, placesReady]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (locationType === "Virtual") {
      if (autocompleteRef.current) {
        try {
          window.google.maps.event.clearInstanceListeners(
            autocompleteRef.current,
          );
        } catch (e) { }
        autocompleteRef.current = null;
      }
      document.querySelectorAll(".pac-container").forEach((el) => el.remove());
    }
  }, [locationType]);

  useEffect(() => {
    if (!placesReady || !inputRef.current) return;
    if (locationType !== "In-person") return;
    if (inputRef.current) {
      inputRef.current.setAttribute("autocomplete", "off");
      inputRef.current.setAttribute("aria-autocomplete", "list");
      inputRef.current.setAttribute("spellcheck", "true");
    }
    const ac = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ["geocode", "establishment"],
      fields: ["formatted_address", "geometry"],
    });
    autocompleteRef.current = ac;
    ac.addListener("place_changed", () => {
      const place = ac.getPlace();
      if (!place?.geometry) return;
      const formattedAddress =
        place.formatted_address || inputRef.current.value;
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      onPlaceSelect({ formattedAddress, lat, lng });
    });
    return () => {
      if (autocompleteRef.current) {
        window.google.maps.event.clearInstanceListeners(
          autocompleteRef.current,
        );
        autocompleteRef.current = null;
      }
      document.querySelectorAll(".pac-container").forEach((el) => el.remove());
    };
  }, [placesReady, locationType]); // eslint-disable-line react-hooks/exhaustive-deps

  const isVirtual = locationType === "Virtual";
  const placeholder = isVirtual
    ? "Please enter meeting link here ....."
    : "Please enter address here .....";
  const label = isVirtual
    ? "Please enter meeting link here"
    : "Please enter address here";

  return (
    <div>
      <TextField
        fullWidth
        inputRef={inputRef}
        placeholder={placeholder}
        label={
          <span>
            {label} <span style={{ color: "red" }}>*</span>
          </span>
        }
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={Boolean(error)}
        inputProps={{
          autoComplete:
            locationType === "In-person" ? "new-password" : undefined,
        }}
      />
      {!placesReady && locationType === "In-person" && (
        <p className="mt-1 text-xs text-gray-400 italic">
          Address lookup unavailable — input saved as free text.
        </p>
      )}
      {gecodingAddress && (
        <p className="mt-1 text-xs text-blue-500 italic">
          Getting location from map link...
        </p>
      )}
    </div>
  );
};

const ZipField = ({
  value,
  onChange,
  onZipResolved,
  countryCode,
  error,
}) => {
  const [placesReady, setPlacesReady] = useState(false);
  const [geocoding, setGeocoding] = useState(false);
  const [geocodeError, setGeocodeError] = useState("");

  const geocoderRef = useRef(null);
  const lastGeocodedZipRef = useRef("");

  // Load Google Maps
  useEffect(() => {
    let mounted = true;

    loadGoogleMapsScript(GOOGLE_MAPS_API_KEY)
      .then((ok) => {
        if (mounted) {
          setPlacesReady(ok);
        }
      })
      .catch(() => {
        if (mounted) {
          setPlacesReady(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  // Create Geocoder once Google Maps is ready
  useEffect(() => {
    if (!placesReady) return;

    if (!window.google?.maps?.Geocoder) {
      return;
    }

    geocoderRef.current = new window.google.maps.Geocoder();

    return () => {
      geocoderRef.current = null;
    };
  }, [placesReady]);

  const geocodeZipCode = async (zipCode) => {
    if (!zipCode?.trim()) {
      return;
    }

    if (!placesReady || !geocoderRef.current) {
      setGeocodeError("ZIP code lookup is currently unavailable.");
      setGeocoding(false);
      return;
    }

    const normalizedZip = zipCode.trim();

    // Don't geocode the exact same ZIP repeatedly
    if (lastGeocodedZipRef.current === normalizedZip) {
      return;
    }

    setGeocoding(true);
    setGeocodeError("");

    try {
      const address = countryCode
        ? `${normalizedZip}, ${countryCode}`
        : normalizedZip;

      const results = await new Promise((resolve, reject) => {
        let settled = false;

        const finish = (callback, value) => {
          if (settled) return;
          settled = true;
          clearTimeout(timeoutId);
          callback(value)
        };

        const timeoutId = setTimeout(() => {
          finish(reject, new Error("GEOCODING_TIMEOUT"));
        }, 10_000);

        try {
          geocoderRef.current.geocode(
            {
              address,
            },
            (results, status) => {
              if (status === "OK") {
                finish(resolve, results);
              } else {
                finish(reject, new Error(status || "GEOCODING_FAILED"));
              }
            }
          );
        } catch (error) {
          finish(reject, error);
        }
      });

      if (!results?.length) {
        throw new Error("ZERO_RESULTS");
      }

      // Prefer a postal-code result if Google returned one
      const postalResult =
        results.find((result) =>
          result.address_components?.some((component) =>
            component.types?.includes("postal_code")
          )
        ) || results[0];

      const location = postalResult.geometry?.location;

      if (!location) {
        throw new Error("NO_LOCATION");
      }

      const lat = location.lat();
      const lng = location.lng();

      lastGeocodedZipRef.current = normalizedZip;

      // Return everything useful to the parent.
      onZipResolved?.({
        zipCode: normalizedZip,
        lat,
        lng,
        formattedAddress: postalResult.formatted_address || "",
        placeId: postalResult.place_id || "",
      });
    } catch (error) {
      console.error("ZIP code geocoding failed:", error);

      lastGeocodedZipRef.current = "";

      let message = "We couldn't find a location for this ZIP/postal code.";

      if (error?.message === "GEOCODING_TIMEOUT") {
        message =
          "ZIP code lookup timed out. Please try again.";
      } else if (error?.message === "REQUEST_DENIED") {
        message =
          "ZIP code lookup is not authorized for this environment.";
      }

      setGeocodeError(message);

      // Let parent know that resolution failed.
      onZipResolved?.({
        zipCode: normalizedZip,
        lat: null,
        lng: null,
        formattedAddress: "",
        placeId: "",
      });
    } finally {
      setGeocoding(false);
    }
  };

  const handleChange = (event) => {
    const newValue = event.target.value;

    // ZIP is intentionally a string.
    // This preserves leading zeros.
    onChange(newValue);

    // If the user edits the ZIP, allow it to be geocoded again.
    if (newValue.trim() !== lastGeocodedZipRef.current) {
      lastGeocodedZipRef.current = "";
      setGeocodeError("");
    }
  };

  const handleBlur = () => {
    geocodeZipCode(value.toString());
  };

  return (
    <div>
      <TextField
        fullWidth
        label={
          <span>
            ZIP / Postal Code{" "}
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        placeholder="Please enter ZIP / postal code"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        error={Boolean(error || geocodeError)}
        helperText={
          // don't show if error comes from parent (it is shown separately in the parent)
          // error ||
          geocodeError ||
          (geocoding
            ? "Finding ZIP code location..."
            : "")
        }
        inputProps={{
          autoComplete: "postal-code",
        }}
      />

      {!placesReady && (
        <p className="mt-1 text-xs text-gray-400 italic">
          ZIP code location lookup unavailable — ZIP will still be saved.
        </p>
      )}
    </div>
  );
};

const CreateEvent = () => {
  const classes = useStyles();
  const TITLE_MAX = 130;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { groupId, id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routerLocation = useLocation();

  const [startDateOpen, setStartDateOpen] = useState(false);
  const [startTimeOpen, setStartTimeOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [endTimeOpen, setEndTimeOpen] = useState(false);

  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const fileInput = useRef(null);
  const lastFetchedLinkRef = useRef(null);
  const firstLinkRef = useRef(null);
  const editPostFormData = useRef(new FormData());
  const originalEvent = useRef(null);

  const { selectedGroups, connections, selectedPostCommunities } = useSelector(
    (s) => s.post,
  );

  const [eventFileLocal, setEventFileLocal] = useState(null);
  const [eventFileNameLocal, setEventFileNameLocal] = useState("");
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [mentionSuggestionsLoading, setMentionSuggestionsLoading] =
    useState(false);
  const [engagementLocationScopes, setEngagementLocationScopes] = useState(locationOptions);
  const [title, setLocalTitle] = useState("");
  const [description, setLocalDescription] = useState("");
  const [ageRestricted, setAgeRestricted] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const [timezone, setTimezone] = useState(browserTimeZone);
  const [locationType, setLocationType] = useState("Virtual");
  const [location, setLocation] = useState("");
  const [virtualTargetLocation, setVirtualTargetLocation] = useState("");
  const [virtualTargetLocationCoordinates, setVirtualTargetLocationCoordinates] = useState(null);
  const [zipCountryCode, setZipCountryCode] = useState("US");
  const [resolvedAddress, setResolvedAddress] = useState(null);
  const [virtualResolvedAddress, setVirtualResolvedAddress] = useState(null);
  const [inPersonResolvedAddress, setInPersonResolvedAddress] = useState(null);
  const [privacy, setPrivacy] = useState("Public");
  const [eventType, setEventType] = useState("");
  const [attendeesFrom, setAttendeesFrom] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [admissionFeeType, setAdmissionFeeType] = useState("Free");
  const [admissionFee, setAdmissionFee] = useState("");
  const [showEventTab, setShowEventTab] = useState(false);
  const [postLinkPreview, setPostLinkPreview] = useState();
  const [postLinkPreviewError, setPostLinkPreviewError] = useState("");
  const [postLinkPreviewLoading, setPostLinkPreviewLoading] = useState(false);
  const [prevFile, setPrevFile] = useState();
  const [prevFileType, setPrevFileType] = useState();
  const [descCursorPos, setDescCursorPos] = useState(0);
  const [postLink, setPostLink] = useState("");
  const [hideLinkPreview, setHideLinkPreview] = useState(false);
  const [originalGroupIds, setOriginalGroupIds] = useState([]);
  const [virtualLocation, setVirtualLocation] = useState("");
  const [inPersonLocation, setInPersonLocation] = useState("");
  const [disabledGroupsEvent, setDisabledGroupsEvent] = useState([]);
  // const [isGroupDisabledForEvents, setIsGroupDisabledForEvents] = useState(
  //   routerLocation?.state?.isGroupDisabledForEvents ?? false, // ✅ initialize from nav state
  // );

  const handleDismissLinkPreview = () => {
    setPostLinkPreview(undefined);
    setHideLinkPreview(true);
    lastFetchedLinkRef.current = null;
  };

  const editId = id || routerLocation?.state?.eventId;
  const isEditMode = Boolean(editId);

  useEffect(() => {
    if (locationType === "Virtual") {
      setLocation(virtualLocation);
      setResolvedAddress(virtualResolvedAddress);
    } else {
      setLocation(inPersonLocation);
      setResolvedAddress(inPersonResolvedAddress);
    }
  }, [locationType]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectDescriptionEmoji = (emoji) => {
    const descArray = description.split("");
    descArray.splice(descCursorPos, 0, emoji);
    const newDesc = descArray.join("");
    setLocalDescription(newDesc);
    setDescCursorPos(descCursorPos + emoji.length);
  };

  const resetFile = () => {
    setEventFileLocal(null);
    setEventFileNameLocal("");
    setPrevFile("");
    setPrevFileType("");
    dispatch(setFileName(""));
    dispatch(setFile(""));
    dispatch(setMedia(""));
    try {
      if (fileInput && fileInput.current) fileInput.current.value = null;
    } catch (e) { }
  };

  const decodeHtmlEntities = (str) => {
    if (!str || typeof str !== "string") return str;
    try {
      const txt = document.createElement("textarea");
      txt.innerHTML = str;
      return txt.value;
    } catch (e) {
      return str;
    }
  };

  const decodeMetadata = (metadata) => {
    if (!metadata || typeof metadata !== "object") return metadata;
    const decoded = {};
    for (const [key, val] of Object.entries(metadata)) {
      decoded[key] = typeof val === "string" ? decodeHtmlEntities(val) : val;
    }
    return decoded;
  };

  const tryFetchOG = (currentDescription) => {
    if (hideLinkPreview) return;
    const extracted = extractUrl(currentDescription || "");
    if (!extracted) return;
    if (firstLinkRef.current && extracted !== firstLinkRef.current) return;
    if (extracted === lastFetchedLinkRef.current) return;
    if (!validator.isURL(extracted)) {
      setPostLinkPreviewError("Invalid URL in description.");
      return;
    }
    firstLinkRef.current = extracted;
    lastFetchedLinkRef.current = extracted;
    setHideLinkPreview(false);
    setPostLinkPreviewLoading(true);
    setPostLinkPreviewError("");
    setPostLink(extracted);
    resetFile();
    dispatch(
      getLinkMetadata({
        link: extracted,
        onSuccess: (metadata) => {
          const meta = decodeMetadata(metadata);
          if (!meta?.ogDescription && (!meta?.ogImage || meta.ogImage.length === 0)) {
            setPostLinkPreviewError("Please double-check the url and try again.");
            return;
          }
          setPostLinkPreview({ sourceLink: extracted, ...meta });
          if (meta?.ogTitle) {
            setLocalTitle((prev) =>
              prev ? `${prev} ${meta.ogTitle}` : meta.ogTitle,
            );
          }
          if (meta?.ogDescription) {
            const currentDesc = (currentDescription || "").trim();
            const newDesc = currentDesc
              ? `${currentDesc}\n\n${meta.ogDescription}`
              : meta.ogDescription;
            setLocalDescription(newDesc);
          }
        },
        onError: (error) => setPostLinkPreviewError(error),
      }),
    ).finally(() => setPostLinkPreviewLoading(false));
  };

  useEffect(() => {
    if (!isEditMode) dispatch(resetPost());
    try {
      localStorage.removeItem("post_connections_initialized");
    } catch (e) { }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const initGroupSelection = async () => {
      if (!groupId) return;
      try {
        const res = await axios.get(`${GET_GROUP}/${groupId}/1`);
        const grp = res.data.group || res.data;
        if (grp) {
          dispatch(addToGroups(grp.id));
          dispatch(setIsGroupOnlyPost(true));
          if (grp.community && grp.community.id)
            dispatch(addToPostCommunities(grp.community.id));
          setShowEventTab(true);
        }
      } catch (e) { }
    };
    initGroupSelection();
  }, [groupId, dispatch]);

  useEffect(() => {
    const loadEngagementLocationScopes = async () => {
      const communityId = selectedPostCommunities?.[0];
      if (!communityId) {
        // setEngagementLocationScopes(locationOptions);
        return;
      }
      try {
        const response = await axios.get(`/engagement/${communityId}`);
        if (
          response.data?.locationScope &&
          response.data.locationScope.length > 0
        ) {
          setEngagementLocationScopes(
            response.data.locationScope.map((s) =>
              typeof s === "string" ? s : `${s.label} (Up to ${s.miles} mile${s.miles === 1 ? "" : "s"})`,
            ),
          );
        } else {
          setEngagementLocationScopes(locationOptions);
        }
      } catch (err) {
        setEngagementLocationScopes(locationOptions);
      }
    };
    loadEngagementLocationScopes();
  }, [selectedPostCommunities]);

  // useEffect(() => {
  //   if (selectedGroups && selectedGroups.length > 0) {
  //     const groupId = selectedGroups[0];
  //     axios
  //       .get(`${CHECK_GROUP_DISABLED_FOR_EVENTS}/${groupId}`)
  //       .then((res) => {
  //         setIsGroupDisabledForEvents(res.data.isDisabled);
  //         console.log("res.data.isDisabled");
  //       })
  //       .catch(() => {
  //         setIsGroupDisabledForEvents(false);
  //       });
  //   }
  // }, [selectedGroups]);

  const restoreResolvedAddress = (eventData) => {
    if (
      eventData.locationCoordinates?.lat != null &&
      eventData.locationCoordinates?.lng != null
    ) {
      const addressData = {
        formattedAddress:
          eventData.locationFormatted || eventData.location || "",
        lat: eventData.locationCoordinates.lat,
        lng: eventData.locationCoordinates.lng,
      };
      setResolvedAddress(addressData);
      // Store in the appropriate location type state
      if ((eventData.locationType || "Virtual") === "Virtual") {
        setVirtualResolvedAddress(addressData);
      } else {
        setInPersonResolvedAddress(addressData);
      }
    }
  };

  const buildOriginalSnapshot = (ev, tz) => ({
    title: ev.title || "",
    description: ev.description || "",
    ageRestricted: Boolean(ev.ageRestricted),
    startDate: extractDate(ev.startTime),
    endDate: extractDate(ev.endTime),
    startTime: extractTime(ev.startTime),
    endTime: extractTime(ev.endTime),
    timezone: ev.timezone || tz || "",
    locationType: ev.locationType || "Virtual",
    location: ev.location || "",
    locationFormatted: ev.locationFormatted ?? null,
    locationCoordinates: ev.locationCoordinates ?? null,
    privacy: ev.privacy || "Public",
    eventType: ev.eventType || "",
    attendeesFrom: ev.attendeesFrom || "",
    minAge: ev.minAge ?? "",
    maxAge: ev.maxAge ?? "",
    admissionFeeType: ev.admissionFeeType || "Free",
    admissionFee: ev.admissionFeeType === "Free" ? "" : ev.admissionFee || "",
    groups: ev.groups ? ev.groups.map((g) => String(g.id || g)) : [],
    connections: ev.connections
      ? ev.connections.map((c) => String(c.id || c))
      : [],
    media: ev.media?.id ?? null,
    postLink: ev.postLink || null,
    postLinkMetadata: parseMetadata(ev.postLinkMetadata),
    hideLinkPreview: Boolean(ev.hideLinkPreview),
  });

  useEffect(() => {
    if (!editId) return;

    const editData = routerLocation?.state?.eventData;

    const normalizeId = (g) => {
      if (g == null) return null;
      if (typeof g === "number") return g;
      if (typeof g === "string" && g.trim() !== "")
        return isNaN(Number(g)) ? g : Number(g);
      if (typeof g === "object") return g.id ?? g.groupId ?? null;
      return null;
    };

    const loadEvent = async () => {
      try {
        if (editData) {
          setLocalTitle(editData.title || "");
          setLocalDescription(editData.description || "");
          setAgeRestricted(Boolean(editData.ageRestricted));
          setStartDate(extractDate(editData.startTime));
          setEndDate(extractDate(editData.endTime));
          setStartTime(extractTime(editData.startTime));
          setEndTime(extractTime(editData.endTime));
          setTimezone(editData.timezone || "");
          setLocationType(editData.locationType || "Virtual");
          setLocation(editData.location || "");
          if ((editData.locationType || "Virtual") === "Virtual") {
            setVirtualLocation(editData.location || "");
            setVirtualTargetLocation(editData.virtualTargetLocation || "");
            setVirtualTargetLocationCoordinates(editData.virtualTargetLocationCoordinates || null);
            setZipCountryCode(editData.zipCountryCode || "US");
          } else {
            setInPersonLocation(editData.location || "");
          }
          setPrivacy(editData.privacy || "Public");
          setEventType(editData.eventType || "");
          setAttendeesFrom(editData.attendeesFrom || "");
          setMinAge(editData.minAge ?? "");
          setMaxAge(editData.maxAge ?? "");
          setAdmissionFeeType(editData.admissionFeeType || "Free");
          setAdmissionFee(
            editData.admissionFeeType === "Free"
              ? ""
              : editData.admissionFee || "",
          );

          if (editData.groups && editData.groups.length > 0) {
            const ids = editData.groups
              .map((g) => normalizeId(g))
              .filter((x) => x !== null && x !== undefined);
            dispatch(addAllToGroups(ids));
            setOriginalGroupIds(ids.map(String));
          }

          if (editData.communities && editData.communities.length > 0) {
            dispatch(
              addAllToPostCommunities(
                editData.communities
                  .map((c) => (c && (c.id ?? c)) || null)
                  .filter((x) => x != null),
              ),
            );
          }
          dispatch(clearConnections());
          if (
            editData.connections !== undefined &&
            editData.connections.length > 0
          ) {
            dispatch(
              addAllToConnections(
                editData.connections
                  .map((c) => (c && (c.id ?? c)) || null)
                  .filter((x) => x != null),
              ),
            );
          }
          localStorage.setItem("post_connections_initialized", "1");

          if (editData.media && editData.media.currBucketUrl) {
            setPrevFile(editData.media.currBucketUrl);
            setPrevFileType(editData.media.fileType || "image");
          }

          restoreResolvedAddress(editData);

          const savedHide = Boolean(editData.hideLinkPreview);
          const meta = parseMetadata(editData.postLinkMetadata);
          if (editData.postLink) setPostLink(editData.postLink);
          setHideLinkPreview(savedHide);

          if (meta && !savedHide) {
            setPostLinkPreview(meta);
            resetFile();
            firstLinkRef.current = editData.postLink || null;
            lastFetchedLinkRef.current = editData.postLink || null;
          } else if (editData.postLink && !savedHide) {
            const link = editData.postLink;
            firstLinkRef.current = link;
            lastFetchedLinkRef.current = link;
            setPostLinkPreviewLoading(true);
            resetFile();
            dispatch(
              getLinkMetadata({
                link,
                onSuccess: (metadata) => {
                  const fetched = decodeMetadata(metadata);
                  setPostLinkPreview({ sourceLink: link, ...fetched });
                },
                onError: () => { },
              }),
            ).finally(() => setPostLinkPreviewLoading(false));
          }

          originalEvent.current = buildOriginalSnapshot(editData, "");
        } else {
          const res = await axios.get(`/event/${editId}`);
          const ev = res.data?.event || res.data;
          if (!ev) return;

          setLocalTitle(ev.title || "");
          setLocalDescription(ev.description || "");
          setAgeRestricted(Boolean(ev.ageRestricted));
          setStartDate(extractDate(ev.startTime));
          setEndDate(extractDate(ev.endTime));
          setStartTime(extractTime(ev.startTime));
          setEndTime(extractTime(ev.endTime));
          setTimezone(ev.timezone || browserTimeZone);
          setLocationType(ev.locationType || "Virtual");
          setLocation(ev.location || "");
          if ((ev.locationType || "Virtual") === "Virtual") {
            setVirtualLocation(ev.location || "");
            setVirtualTargetLocation(ev.virtualTargetLocation || "");
            setVirtualTargetLocationCoordinates(ev.virtualTargetLocationCoordinates || null);
            setZipCountryCode(ev.zipCountryCode || "US");
          } else {
            setInPersonLocation(ev.location || "");
          }
          setPrivacy(ev.privacy || "Public");
          setEventType(ev.eventType || "");
          setAttendeesFrom(ev.attendeesFrom || "");
          setMinAge(ev.minAge ?? "");
          setMaxAge(ev.maxAge ?? "");
          setAdmissionFeeType(ev.admissionFeeType || "Free");
          setAdmissionFee(
            ev.admissionFeeType === "Free" ? "" : ev.admissionFee || "",
          );

          if (ev.groups && ev.groups.length > 0) {
            const ids = ev.groups
              .map((g) => normalizeId(g))
              .filter((x) => x !== null && x !== undefined);
            dispatch(addAllToGroups(ids));
            setOriginalGroupIds(ids.map(String));
          }

          if (ev.communities && ev.communities.length > 0) {
            dispatch(
              addAllToPostCommunities(
                ev.communities
                  .map((c) => (c && (c.id ?? c)) || null)
                  .filter((x) => x != null),
              ),
            );
          }
          dispatch(clearConnections());
          if (ev.connections !== undefined && ev.connections.length > 0) {
            dispatch(
              addAllToConnections(
                ev.connections
                  .map((c) => (c && (c.id ?? c)) || null)
                  .filter((x) => x != null),
              ),
            );
          }
          localStorage.setItem("post_connections_initialized", "1");

          if (ev.media && ev.media.currBucketUrl) {
            setPrevFile(ev.media.currBucketUrl);
            setPrevFileType(ev.media.fileType || "image");
          }

          restoreResolvedAddress(ev);

          const savedHide = Boolean(ev.hideLinkPreview);
          const meta = parseMetadata(ev.postLinkMetadata);
          if (ev.postLink) setPostLink(ev.postLink);
          setHideLinkPreview(savedHide);

          if (meta && !savedHide) {
            setPostLinkPreview(meta);
            resetFile();
            firstLinkRef.current = ev.postLink || null;
            lastFetchedLinkRef.current = ev.postLink || null;
          } else if (ev.postLink && !savedHide) {
            const link = ev.postLink;
            firstLinkRef.current = link;
            lastFetchedLinkRef.current = link;
            setPostLinkPreviewLoading(true);
            resetFile();
            dispatch(
              getLinkMetadata({
                link,
                onSuccess: (metadata) => {
                  const fetched = decodeMetadata(metadata);
                  setPostLinkPreview({ sourceLink: link, ...fetched });
                },
                onError: () => { },
              }),
            ).finally(() => setPostLinkPreviewLoading(false));
          }

          originalEvent.current = buildOriginalSnapshot(ev, browserTimeZone);
        }
      } catch (e) {
        console.error("Error loading event:", e);
      }
    };

    loadEvent();
  }, [editId, routerLocation?.state]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (minAge === "" || minAge === null) return;
    const n = Number(minAge);
    if (!Number.isNaN(n) && n >= 14) setAgeRestricted(true);
  }, [minAge]);

  const descWasSetRef = useRef(false);

  useEffect(() => {
    if (!description) {
      if (descWasSetRef.current) {
        firstLinkRef.current = null;
        lastFetchedLinkRef.current = null;
        setPostLinkPreview(undefined);
        setHideLinkPreview(false);
        setPostLinkPreviewError("");
      }
      return;
    }
    descWasSetRef.current = true;

    const currentUrl = extractUrl(description);
    if (!currentUrl) {
      setPostLinkPreviewError("");
    } else if (firstLinkRef.current && currentUrl !== firstLinkRef.current) {
      firstLinkRef.current = null;
      lastFetchedLinkRef.current = null;
      setPostLinkPreview(undefined);
      setPostLinkPreviewError("");
    }

    let mentionStrings = description.match(/\B@[a-z0-9_-]+/gi);
    setMentionSuggestions([]);
    if (mentionStrings?.length) {
      mentionStrings = mentionStrings.map((str) => str.slice(1));
      setMentionSuggestionsLoading(true);
      axios
        .get("/user/get-user-by-usernames", {
          params: { usernames: mentionStrings },
        })
        .then((response) => setMentionSuggestions(response.data))
        .finally(() => setMentionSuggestionsLoading(false));
    }
  }, [description]);

  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 45 * 1024 * 1024) {
        toast.error("File size should be less than 45MB");
        return;
      }
      const f = e.target.files[0];
      setEventFileLocal(f);
      setEventFileNameLocal(f.name || "");
      setPrevFile(URL.createObjectURL(f));
      setPrevFileType(f.type.split("/")[0]);
    }
    if (e.target.value) e.target.value = null;
  };

  // ─── FE validation (mirrors Joi schema) ───────────────────────────────────
  const validate = () => {
    const e = {};

    if (!title || !title.trim()) e.title = "Title is required.";
    else if (title.length > TITLE_MAX)
      e.title = `Title must not exceed ${TITLE_MAX} characters.`;

    if (!description || !description.trim())
      e.description = "Description is required.";

    if (!startDate) e.startDate = "Start date is required.";
    if (!startTime) e.startTime = "Start time is required.";
    if (!endDate) e.endDate = "End date is required.";
    if (!endTime) e.endTime = "End time is required.";

    // Past date check (day-level only) — skip when editing an existing event
    if (!isEditMode) {
      const today = dayjs().startOf("day");
      if (startDate && dayjs(startDate).isBefore(today))
        e.startDate = "Start date has already passed.";
      if (endDate && dayjs(endDate).isBefore(today))
        e.endDate = "End date has already passed.";
    }

    // Date/time ordering
    if (startDate && startTime && endDate && endTime) {
      const s = dayjs(`${startDate}T${startTime}`);
      const en = dayjs(`${endDate}T${endTime}`);
      if (en.isBefore(s) || en.isSame(s)) {
        if (startDate === endDate) {
          e.endTime = "End time must be after the start time.";
        } else {
          e.endDate = "End date must be on or after the start date.";
        }
      }
    }

    if (
      (locationType === "In-person" || locationType === "Virtual") &&
      !location.trim()
    )
      e.location = "Location is required.";

    if (locationType === "Virtual" && !virtualTargetLocation?.trim())
      e.virtualTargetLocation = "Target Audience Location is required."
    else if (locationType === "Virtual" && virtualTargetLocation.length < 5)
      e.virtualTargetLocation = "ZIP Code must be at least 5 digits."
    else if (locationType === "Virtual" && (!virtualTargetLocationCoordinates?.lat || !virtualTargetLocationCoordinates?.lng))
      e.virtualTargetLocation = "Target Audience Location could not be fetched. Please try re-entering the ZIP code."

    if (!eventType) e.eventType = "Event type is required.";

    if (!admissionFeeType)
      e.admissionFeeType = "Admission fee type is required.";
    if (admissionFeeType === "Paid" && !admissionFee.trim())
      e.admissionFee = "Admission fee is required.";

    if (minAge !== "" && minAge !== null && isNaN(Number(minAge)))
      e.minAge = "Minimum Age Range must be a number.";
    if (maxAge !== "" && maxAge !== null && isNaN(Number(maxAge)))
      e.maxAge = "Maximum Age Range must be a number.";
    if (
      ageRestricted &&
      minAge !== "" &&
      minAge !== null &&
      Number(minAge) < 14
    )
      e.minAge =
        "Minimum age must be at least 14 when age restriction is enabled.";
    if (
      minAge !== "" &&
      minAge !== null &&
      maxAge !== "" &&
      maxAge !== null &&
      Number(maxAge) < Number(minAge)
    )
      e.maxAge =
        "Maximum Age Range must be greater than or equal to Minimum Age Range.";

    return e;
  };
  // ──────────────────────────────────────────────────────────────────────────

  const handleSubmit = async (ev) => {
    ev.preventDefault();

    // Run FE validation first — stop before any API call
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setLoading(true);

    try {
      let mediaId = null;
      let mediaChanged = false;
      if (eventFileLocal) {
        const formData = new FormData();
        formData.append("file", eventFileLocal);
        try {
          const uploadRes = await axios.post(UPLOAD_FILE, formData);
          if (uploadRes?.data) {
            mediaId = uploadRes.data;
            mediaChanged = true;
          }
        } catch (e) { }
      } else if (!prevFile && originalEvent.current?.media) {
        mediaId = null;
        mediaChanged = true;
      }

      if (isEditMode && originalEvent.current) {
        const orig = originalEvent.current;

        const currentGroups =
          selectedGroups && selectedGroups.length > 0
            ? selectedGroups
            : groupId
              ? [groupId]
              : [];
        const currentConnections =
          connections && connections.length > 0 ? connections : [];

        const diff = {};

        const isEmpty = (v) => v === null || v === undefined || v === "";
        const scalarChanged = (cur, orig) => {
          if (isEmpty(cur) && isEmpty(orig)) return false;
          return String(cur) !== String(orig);
        };

        if (scalarChanged(title, orig.title)) diff.title = title;
        if (scalarChanged(description, orig.description))
          diff.description = description;
        if (Boolean(ageRestricted) !== Boolean(orig.ageRestricted))
          diff.ageRestricted = ageRestricted;
        if (scalarChanged(timezone, orig.timezone)) diff.timezone = timezone;
        if (scalarChanged(locationType, orig.locationType))
          diff.locationType = locationType;
        if (scalarChanged(location, orig.location)) diff.location = location;
        if (scalarChanged(virtualTargetLocation, orig.virtualTargetLocation)) diff.virtualTargetLocation = virtualTargetLocation;
        if (scalarChanged(zipCountryCode, orig.zipCountryCode)) diff.zipCountryCode = zipCountryCode;
        if (scalarChanged(privacy, orig.privacy)) diff.privacy = privacy;
        if (scalarChanged(eventType, orig.eventType))
          diff.eventType = eventType;
        if (scalarChanged(attendeesFrom, orig.attendeesFrom))
          diff.attendeesFrom = attendeesFrom;
        if (Boolean(hideLinkPreview) !== Boolean(orig.hideLinkPreview))
          diff.hideLinkPreview = hideLinkPreview;
        if (scalarChanged(postLink || null, orig.postLink))
          diff.postLink = postLink || null;
        if (scalarChanged(admissionFeeType, orig.admissionFeeType))
          diff.admissionFeeType = admissionFeeType;

        const origFee =
          orig.admissionFeeType === "Paid" ? orig.admissionFee || "" : null;
        const curFee = admissionFeeType === "Paid" ? admissionFee || "" : null;
        if (scalarChanged(curFee, origFee)) diff.admissionFee = curFee;

        const curStartDate = startDate
          ? dayjs(startDate).format("YYYY-MM-DD")
          : "";
        const curEndDate = endDate ? dayjs(endDate).format("YYYY-MM-DD") : "";
        const curStartTime = startTime
          ? dayjs(`2000-01-01T${startTime}`).format("HH:mm")
          : "";
        const curEndTime = endTime
          ? dayjs(`2000-01-01T${endTime}`).format("HH:mm")
          : "";
        const origStartDate = orig.startDate
          ? dayjs(orig.startDate).format("YYYY-MM-DD")
          : "";
        const origEndDate = orig.endDate
          ? dayjs(orig.endDate).format("YYYY-MM-DD")
          : "";
        const origStartTime = orig.startTime
          ? dayjs(`2000-01-01T${orig.startTime}`).format("HH:mm")
          : "";
        const origEndTime = orig.endTime
          ? dayjs(`2000-01-01T${orig.endTime}`).format("HH:mm")
          : "";

        if (curStartDate !== origStartDate) diff.startDate = curStartDate;
        if (curStartTime !== origStartTime) diff.startTime = curStartTime;
        if (curEndDate !== origEndDate) diff.endDate = curEndDate;
        if (curEndTime !== origEndTime) diff.endTime = curEndTime;

        const origMinAge =
          orig.minAge !== "" && orig.minAge != null
            ? Number(orig.minAge)
            : null;
        const origMaxAge =
          orig.maxAge !== "" && orig.maxAge != null
            ? Number(orig.maxAge)
            : null;
        const curMinAge =
          minAge !== "" && minAge != null ? Number(minAge) : null;
        const curMaxAge =
          maxAge !== "" && maxAge != null ? Number(maxAge) : null;
        if (curMinAge !== origMinAge) diff.minAge = curMinAge;
        if (curMaxAge !== origMaxAge) diff.maxAge = curMaxAge;

        const curLocationFormatted = resolvedAddress?.formattedAddress ?? null;
        const curLocationCoordinates =
          locationType !== "Virtual" && resolvedAddress?.lat != null
            ? { lat: resolvedAddress.lat, lng: resolvedAddress.lng }
            : locationType === "Virtual" && virtualTargetLocationCoordinates?.lat != null ? { lat: virtualTargetLocationCoordinates.lat, lng: virtualTargetLocationCoordinates.lng } : null;
        if (
          JSON.stringify(curLocationCoordinates) !==
          JSON.stringify(orig.locationCoordinates)
        ) {
          diff.locationFormatted = curLocationFormatted;
          diff.locationCoordinates = curLocationCoordinates;
        } else if (
          scalarChanged(curLocationFormatted, orig.locationFormatted)
        ) {
          diff.locationFormatted = curLocationFormatted;
        }

        if (
          JSON.stringify(postLinkPreview || null) !==
          JSON.stringify(orig.postLinkMetadata)
        ) {
          diff.postLinkMetadata = postLinkPreview || null;
        }

        const groupsSorted = [...currentGroups].map(String).sort().join(",");
        const origGroupsSorted = [...orig.groups].map(String).sort().join(",");
        if (groupsSorted !== origGroupsSorted) diff.groups = currentGroups;

        const connSorted = [...currentConnections].map(String).sort().join(",");
        const origConnSorted = [...orig.connections]
          .map(String)
          .sort()
          .join(",");
        if (connSorted !== origConnSorted)
          diff.connections = currentConnections;

        if (mediaChanged) diff.media = mediaId;

        if (Object.keys(diff).length === 0) {
          toast.info("No changes to save.");
          setLoading(false);

          const returnTo = routerLocation?.state?.returnTo;
          if (returnTo) {
            navigate(returnTo, { replace: true });
          } else {
            const returnToGroupId =
              routerLocation?.state?.returnToGroupId || groupId;
            if (returnToGroupId) {
              navigate(`/group/info/${returnToGroupId}`, { replace: true });
            } else {
              navigate(ROOT, { replace: true });
            }
          }

          return;
        }

        const res = await axios.post(`/event/update/${editId}`, diff);
        toast.success("Event updated successfully");

        dispatch(resetPost());
        if (res?.data) {
          const rawId = res.data.id;
          const normalizedId =
            typeof rawId === "string" && rawId.startsWith("event-")
              ? rawId
              : `event-${rawId}`;
          dispatch(
            updatePost({
              ...res.data,
              id: normalizedId,
              postLinkMetadata:
                postLinkPreview || res.data.postLinkMetadata || null,
              hideLinkPreview,
            }),
          );
        }

        const returnTo = routerLocation?.state?.returnTo;
        if (returnTo) {
          navigate(returnTo, { replace: true });
        } else {
          const returnToGroupId =
            routerLocation?.state?.returnToGroupId || groupId;
          if (returnToGroupId) {
            navigate(`/group/info/${returnToGroupId}`, { replace: true });
          } else {
            navigate(ROOT, { replace: true });
          }
        }
      } else {
        const payload = {
          title,
          description,
          ageRestricted,
          startDate: startDate.toString().split("T")[0],
          endDate: endDate.toString().split("T")[0],
          startTime,
          endTime,
          timezone,
          locationType,
          location,
          virtualTargetLocation,
          zipCountryCode,
          locationFormatted: resolvedAddress?.formattedAddress ?? null,
          locationCoordinates:
            locationType !== "Virtual" && resolvedAddress?.lat != null
              ? { lat: resolvedAddress.lat, lng: resolvedAddress.lng }
              : locationType === "Virtual" && virtualTargetLocationCoordinates?.lat != null ? { lat: virtualTargetLocationCoordinates.lat, lng: virtualTargetLocationCoordinates.lng } : null,
          privacy,
          eventType,
          ...(attendeesFrom ? { attendeesFrom } : {}),
          minAge: minAge ? Number(minAge) : null,
          maxAge: maxAge ? Number(maxAge) : null,
          admissionFeeType,
          admissionFee: admissionFeeType === "Paid" ? admissionFee : null,
          groups:
            selectedGroups && selectedGroups.length > 0
              ? selectedGroups
              : groupId
                ? [groupId]
                : [],
          connections: connections && connections.length > 0 ? connections : [],
          media: mediaId || null,
          postLink: postLink || null,
          postLinkMetadata: postLinkPreview || null,
          hideLinkPreview,
        };

        const res = await axios.post("/event/create", payload);
        toast.success("Event post created successfully");

        dispatch(resetPost());
        if (res?.data) {
          const rawId = res.data.id;
          const normalizedId =
            typeof rawId === "string" && rawId.startsWith("event-")
              ? rawId
              : `event-${rawId}`;
          dispatch(
            addToPosts({
              ...res.data,
              id: normalizedId,
              postLinkMetadata:
                postLinkPreview || res.data.postLinkMetadata || null,
              hideLinkPreview,
            }),
          );
        }

        try {
          const createdGroups = res?.data?.groups || [];
          const groupIds = Array.isArray(createdGroups) ? createdGroups : [];
          groupIds.forEach((g) => {
            try {
              const gid = typeof g === "object" ? g.id : g;
              if (gid) localStorage.removeItem(`group-${gid}-cache`);
            } catch (err) { }
          });
          // Also clear by the groupId from route/state in case groups isn't populated yet
          const fallbackGroupId =
            routerLocation?.state?.returnToGroupId ||
            (selectedGroups && selectedGroups.length > 0 ? selectedGroups[0] : null) ||
            groupId;
          if (fallbackGroupId) localStorage.removeItem(`group-${fallbackGroupId}-cache`);
        } catch (err) { }

        try {
          localStorage.setItem("stream-refresh", Date.now().toString());
          window.dispatchEvent(new Event("stream:refresh"));
        } catch (e) { }

        const returnTo = routerLocation?.state?.returnTo;
        if (returnTo) {
          navigate(returnTo, { replace: true });
        } else {
          const returnToGroupId =
            routerLocation?.state?.returnToGroupId ||
            (selectedGroups && selectedGroups.length > 0
              ? selectedGroups[0]
              : null) ||
            groupId;
          if (returnToGroupId) {
            navigate(`/group/info/${returnToGroupId}`, { replace: true });
          } else {
            navigate(ROOT, { replace: true });
          }
        }
      }
    } catch (err) {
      // Route BE Joi errors to the correct field — no toast for field-level errors
      const detail = err?.response?.data?.message || err?.response?.data?.error;
      if (detail) {
        const msg =
          typeof detail === "string" ? detail : JSON.stringify(detail);
        if (/title/i.test(msg)) setErrors((prev) => ({ ...prev, title: msg }));
        else if (/description/i.test(msg))
          setErrors((prev) => ({ ...prev, description: msg }));
        else if (/start date|startDate/i.test(msg))
          setErrors((prev) => ({ ...prev, startDate: msg }));
        else if (/end date|endDate/i.test(msg))
          setErrors((prev) => ({ ...prev, endDate: msg }));
        else if (/start time|startTime/i.test(msg))
          setErrors((prev) => ({ ...prev, startTime: msg }));
        else if (/end time|endTime/i.test(msg))
          setErrors((prev) => ({ ...prev, endTime: msg }));
        else if (/location/i.test(msg))
          setErrors((prev) => ({ ...prev, location: msg }));
        else if (/target location/i.test(msg) || /country code/i.test(msg))
          setErrors((prev) => ({ ...prev, virtualTargetLocation: msg }));
        else if (/event type|eventType/i.test(msg))
          setErrors((prev) => ({ ...prev, eventType: msg }));
        else if (/admission fee type/i.test(msg))
          setErrors((prev) => ({ ...prev, admissionFeeType: msg }));
        else if (/admission fee/i.test(msg))
          setErrors((prev) => ({ ...prev, admissionFee: msg }));
        else if (/minimum age/i.test(msg))
          setErrors((prev) => ({ ...prev, minAge: msg }));
        else if (/maximum age/i.test(msg))
          setErrors((prev) => ({ ...prev, maxAge: msg }));
        else if (/dates has already passed/i.test(msg))
          setErrors((prev) => ({ ...prev, endDate: msg }));
        else toast.error(msg);
      } else {
        toast.error("Failed to save event. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const userToggledShowRef = useRef(false);
  useEffect(() => {
    if (!userToggledShowRef.current) return;
    userToggledShowRef.current = false;
    if (!hideLinkPreview) {
      const link = firstLinkRef.current || postLink;
      if (!link) return;
      if (postLinkPreview) return;
      setPostLinkPreviewLoading(true);
      dispatch(
        getLinkMetadata({
          link,
          onSuccess: (metadata) => {
            const meta = decodeMetadata(metadata);
            resetFile();
            setPostLinkPreview({ sourceLink: link, ...meta });
          },
          onError: (error) => setPostLinkPreviewError(error),
        }),
      ).finally(() => setPostLinkPreviewLoading(false));
    }
  }, [hideLinkPreview]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Layout>
      <Title
        onBack={() => {
          const returnTo = routerLocation?.state?.returnTo;
          if (returnTo) {
            navigate(returnTo, { replace: true });
          } else {
            const returnToGroupId =
              routerLocation?.state?.returnToGroupId || groupId;
            if (returnToGroupId) {
              navigate(`/group/info/${returnToGroupId}`, { replace: true });
            } else {
              navigate(ROOT, { replace: true });
            }
          }
        }}
      >
        Add to Stream
      </Title>
      <PostTypeTabs
        activeTab="event"
        selectedGroups={selectedGroups}
        showEventTab={showEventTab}
        isEditing={Boolean(editId)}
      // isGroupDisabledForEvents={isGroupDisabledForEvents}
      />
      <form onSubmit={handleSubmit} className="m-auto w-5/6 mb-[100px]">
        {postLinkPreviewLoading || postLinkPreview || hideLinkPreview ? (
          postLinkPreviewLoading ? (
            <div className="flex items-center justify-center py-6">
              <CircularProgress size={24} />
            </div>
          ) : hideLinkPreview ? (
            <div className="flex justify-end my-2">
              <Button
                variant="contained"
                onClick={() => {
                  userToggledShowRef.current = true;
                  setHideLinkPreview(false);
                }}
              >
                Show link preview
              </Button>
            </div>
          ) : (
            <div className="relative my-2">
              <OpenGraphInfo className="mb-4" data={postLinkPreview} />
              <Tooltip title="Remove link preview">
                <CloseIcon
                  className="cursor-pointer absolute -top-2 -right-2"
                  onClick={handleDismissLinkPreview}
                />
              </Tooltip>
            </div>
          )
        ) : (
          <div className="flex justify-center">
            <div
              className={clsx(
                prevFile ? "" : classes.colorGreen,
                prevFile ? "" : classes.borderGreen,
                "my-5 flex relative flex-col items-center justify-center w-40 min-h-40 border-dashed p-4 rounded-full",
                prevFile ? "w-full" : "border-dashed cursor-pointer",
              )}
              onClick={() => fileInput.current.click()}
            >
              {prevFile && (
                <Typography
                  color={"red"}
                  onClick={(e) => {
                    e.stopPropagation();
                    editPostFormData.current.set("mediaId", "");
                    setEventFileLocal(null);
                    setEventFileNameLocal("");
                    setPrevFile(null);
                    setPrevFileType(null);
                  }}
                  className="absolute cursor-pointer top-5 left-5"
                >
                  X
                </Typography>
              )}
              <div>
                <CardMedia
                  crossOrigin="anonymous"
                  component={"video"}
                  controls
                  className={clsx(
                    "mb-2 h-40",
                    prevFile && prevFileType === "video" ? "" : "hidden",
                  )}
                  image={prevFile}
                  alt="Stream Media"
                  muted
                />
                <img
                  src={prevFile}
                  alt="Upload"
                  className={clsx(
                    "mb-2 h-40 object-contain",
                    prevFile && prevFileType === "image" ? "" : "hidden",
                  )}
                />
              </div>
              {!Boolean(prevFile) && (
                <img
                  src={upload}
                  alt="Upload"
                  className="mb-2 object-contain"
                />
              )}
              <Typography>
                {eventFileNameLocal ? eventFileNameLocal : "Add File"}
              </Typography>
              {!eventFileNameLocal ? (
                <Typography fontSize={10} className="text-center">
                  (Maximum 45 MBs)
                </Typography>
              ) : null}
              <input
                className="hidden"
                multiple={true}
                type="file"
                accept="image/*,video/*"
                ref={fileInput}
                onChange={onFileChange}
              />
            </div>
          </div>
        )}
        {/* ── Title ── */}
        <TextField
          fullWidth
          placeholder="Title or Summary"
          label={
            <span>
              Title or Summary <span style={{ color: "red" }}>*</span>
            </span>
          }
          value={title}
          onChange={(e) => {
            setLocalTitle(e.target.value);
            if (errors.title) setErrors((prev) => ({ ...prev, title: "" }));
          }}
          className="mb-2 noto-font"
          inputProps={{ maxLength: TITLE_MAX }}
          error={Boolean(errors.title)}
        />{" "}
        {errors.title && (
          <p className="text-xs text-red-500 mb-2">{errors.title}</p>
        )}
        {/* ── Description ── */}
        <div className="input-wrapper flex flex-col relative CreateEvent ">
          <MentionsInput
            value={description}
            style={{
              ...mentionsInputStyle,
              "&multiLine": {
                ...mentionsInputStyle["&multiLine"],
                input: {
                  ...mentionsInputStyle["&multiLine"].input,
                  borderColor: errors.description ? "#d32f2f" : "#887E7E",
                  borderWidth: errors.description ? 1 : 2,
                },
              },
            }}
            className="h-32 rounded-md overflow-y-hidden noto-font"
            placeholder="Got something to share? Type it here"
            onChange={(e) => {
              setLocalDescription(e.target.value);
              if (errors.description)
                setErrors((prev) => ({ ...prev, description: "" }));
            }}
            onKeyDown={(e) => {
              if (e.key === " " || e.key === "Enter")
                tryFetchOG(e.target.value);
            }}
            onBlur={(e) => {
              tryFetchOG(e.target.value);
              setDescCursorPos(e.target.selectionStart || description.length);
            }}
            onSelect={(e) => {
              setDescCursorPos(e.target.selectionStart || description.length);
            }}
          >
            <Mention
              trigger="@"
              style={mentionStyle}
              key={mentionSuggestionsLoading}
              isLoading={mentionSuggestionsLoading}
              data={mentionSuggestions?.map((user) => ({
                id: user.userName,
                display: user.userName,
              }))}
              appendSpaceOnAdd
              renderSuggestion={(suggestion, search, value, index, focused) => (
                <MyAvatar
                  name={value}
                  src={
                    mentionSuggestions?.find(
                      (user) => user.userName === suggestion.id,
                    )?.media?.currBucketUrl
                  }
                />
              )}
            />
          </MentionsInput>
          <EmojiSelector
            positionClassName="bottom-1 right-1"
            onSelection={handleSelectDescriptionEmoji}
          />
        </div>
        {errors.description && (
          <p className="text-xs text-red-500 mt-1 mb-1">{errors.description}</p>
        )}
        {postLinkPreviewError && (
          <p className="text-xs italic text-red-500 mt-1">
            {postLinkPreviewError}
          </p>
        )}
        <FormControlLabel
          sx={{
            alignItems: "flex-start",
            display: "flex",
            "& .MuiFormControlLabel-label": { flex: 1, lineHeight: 3 },
          }}
          control={
            <Checkbox
              checked={ageRestricted}
              onChange={(e) => setAgeRestricted(e.target.checked)}
              sx={{ mt: "2px" }}
            />
          }
          label="This content is not suitable for individuals under 14 years of age."
        />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="grid grid-cols-2 gap-4 my-4">
            <div>
              <DatePicker
                label={
                  <span>
                    Start Date <span style={{ color: "red" }}>*</span>
                  </span>
                }
                value={startDate ? dayjs(startDate) : null}
                onChange={(newValue) => {
                  setStartDate(newValue ? newValue.format("YYYY-MM-DD") : "");
                  if (errors.startDate)
                    setErrors((prev) => ({ ...prev, startDate: "" }));
                }}
                disablePast
                open={startDateOpen}
                onOpen={() => setStartDateOpen(true)}
                onClose={() => setStartDateOpen(false)}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    fullWidth: true,
                    onClick: () => setStartDateOpen(true),
                    error: Boolean(errors.startDate),
                    inputProps: { readOnly: false },
                  },
                }}
              />
              {errors.startDate && (
                <p className="text-xs text-red-500 mt-1">{errors.startDate}</p>
              )}
            </div>

            <div>
              <TimePicker
                label={
                  <span>
                    Start Time <span style={{ color: "red" }}>*</span>
                  </span>
                }
                value={startTime ? dayjs(`2000-01-01T${startTime}`) : null}
                onChange={(newValue) => {
                  setStartTime(newValue ? newValue.format("HH:mm") : "");
                  if (errors.startTime)
                    setErrors((prev) => ({ ...prev, startTime: "" }));
                }}
                ampm={true}
                minutesStep={1}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                }}
                open={startTimeOpen}
                onOpen={() => setStartTimeOpen(true)}
                onClose={() => setStartTimeOpen(false)}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    fullWidth: true,
                    onClick: () => setStartTimeOpen(true),
                    error: Boolean(errors.startTime),
                    inputProps: { readOnly: true },
                  },
                }}
              />
              {errors.startTime && (
                <p className="text-xs text-red-500 mt-1">{errors.startTime}</p>
              )}
            </div>

            <div>
              <DatePicker
                label={
                  <span>
                    End Date <span style={{ color: "red" }}>*</span>
                  </span>
                }
                value={endDate ? dayjs(endDate) : null}
                onChange={(newValue) => {
                  setEndDate(newValue ? newValue.format("YYYY-MM-DD") : "");
                  if (errors.endDate)
                    setErrors((prev) => ({ ...prev, endDate: "" }));
                }}
                disablePast
                minDate={startDate ? dayjs(startDate) : undefined}
                open={endDateOpen}
                onOpen={() => setEndDateOpen(true)}
                onClose={() => setEndDateOpen(false)}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    fullWidth: true,
                    onClick: () => setEndDateOpen(true),
                    error: Boolean(errors.endDate),
                    inputProps: { readOnly: true },
                  },
                }}
              />
              {errors.endDate && (
                <p className="text-xs text-red-500 mt-1">{errors.endDate}</p>
              )}
            </div>

            <div>
              <TimePicker
                label={
                  <span>
                    End Time <span style={{ color: "red" }}>*</span>
                  </span>
                }
                value={endTime ? dayjs(`2000-01-01T${endTime}`) : null}
                onChange={(newValue) => {
                  setEndTime(newValue ? newValue.format("HH:mm") : "");
                  if (errors.endTime)
                    setErrors((prev) => ({ ...prev, endTime: "" }));
                }}
                ampm={true}
                minutesStep={1}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                }}
                open={endTimeOpen}
                onOpen={() => setEndTimeOpen(true)}
                onClose={() => setEndTimeOpen(false)}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    fullWidth: true,
                    onClick: () => setEndTimeOpen(true),
                    error: Boolean(errors.endTime),
                    inputProps: { readOnly: true },
                  },
                }}
              />
              {errors.endTime && (
                <p className="text-xs text-red-500 mt-1">{errors.endTime}</p>
              )}
            </div>
          </div>
        </LocalizationProvider>
        <div className="mb-4">
          This event will start on {formatDateTime(startDate, startTime)} and
          end on {formatDateTime(endDate, endTime, timezone, true)}.
        </div>
        {/* ── Location ── */}
        <div className="my-1 font-bold">
          <Typography variant="subtitle1" className="font-bold">
            <span>
              Location: <span style={{ color: "red" }}>*</span>
            </span>
          </Typography>
          <RadioGroup
            row
            value={locationType}
            onChange={(e) => setLocationType(e.target.value)}
          >
            <FormControlLabel
              value="Virtual"
              control={<Radio />}
              label="Virtual"
            />
            <FormControlLabel
              value="In-person"
              control={<Radio />}
              label="In-person"
            />
          </RadioGroup>
          <LocationField
            value={location}
            onChange={(text) => {
              setLocation(text);
              if (errors.location)
                setErrors((prev) => ({ ...prev, location: "" }));
              if (locationType === "Virtual") {
                setVirtualLocation(text);
                setVirtualResolvedAddress(null);
              } else {
                setInPersonLocation(text);
                setInPersonResolvedAddress(null);
              }
            }}
            onPlaceSelect={({ formattedAddress, lat, lng }) => {
              setLocation(formattedAddress);
              const addressData = { formattedAddress, lat, lng };
              setResolvedAddress(addressData);
              if (locationType === "Virtual") {
                setVirtualLocation(formattedAddress);
                setVirtualResolvedAddress(addressData);
              } else {
                setInPersonLocation(formattedAddress);
                setInPersonResolvedAddress(addressData);
              }
              if (errors.location)
                setErrors((prev) => ({ ...prev, location: "" }));
            }}
            locationType={locationType}
            resolvedAddress={resolvedAddress}
            error={errors.location}
          />
        </div>
        {errors.location && (
          <p className="text-xs text-red-500 mt-1">{errors.location}</p>
        )}
        {/* Target Audience Location */}
        {locationType === "Virtual" && (<div className="mb-1 mt-4 font-bold">
          <Typography variant="subtitle1" className="font-bold">
            <span>
              Target Audience Location: <span style={{ color: "red" }}>*</span>
            </span>
          </Typography>
          <div className="mt-2 flex">
            <div>
              <Select
                value={zipCountryCode}
                onChange={(e) => {
                  setZipCountryCode(e.target.value);
                }}
                error={Boolean(errors.virtualTargetLocation)}
                displayEmpty
                renderValue={(selected) =>
                  selected ? (
                    selected
                  ) : (
                    <span className="text-gray-400">
                      Country <span style={{ color: "red" }}>*</span>
                    </span>
                  )
                }
                MenuProps={{
                  PaperProps: {
                    className: "max-h-[200px] sm:max-h-[180px]"
                  }
                }}
              >
                {COUNTRY_CODES.map((element) => <MenuItem value={element.value} className="min-h-[36px] py-0.5 sm:min-h-[36px] sm:py-1" >{element.label}</MenuItem>)}
              </Select>
            </div>
            <ZipField
              countryCode={zipCountryCode}
              value={virtualTargetLocation}
              onChange={(text) => {
                text = parseInt(text.trim().replace(/\D/g, ""), 10);
                if (isNaN(text) || text < 0) {
                  setVirtualTargetLocation("");
                  return;
                }

                if (errors.virtualTargetLocation)
                  setErrors((prev) => ({ ...prev, virtualTargetLocation: "" }));
                setVirtualTargetLocation(text.toString());
              }}
              onZipResolved={(result) => {
                setVirtualTargetLocation(result.zipCode);

                if (!result.lat || !result.lng) {
                  toast.error("Unable to find coordinates for the provided ZIP code. Please try again.")
                }

                setVirtualTargetLocationCoordinates({
                  lat: result.lat,
                  lng: result.lng,
                });
              }}
              error={errors.virtualTargetLocation}
            />
          </div>
        </div>
        )}
        {errors.virtualTargetLocation && (
          <p className="text-xs text-red-500 mt-1">{errors.virtualTargetLocation}</p>
        )}
        {/* ── Privacy ── */}
        <div className="my-4">
          <Typography variant="subtitle1" className="font-bold">
            <span>
              Event is: <span style={{ color: "red" }}>*</span>
            </span>
          </Typography>
          <RadioGroup
            row
            value={privacy}
            onChange={(e) => setPrivacy(e.target.value)}
          >
            <FormControlLabel
              value="Public"
              control={<Radio />}
              label="Public"
            />
            <FormControlLabel
              value="Private"
              control={<Radio />}
              label="Private"
            />
          </RadioGroup>
        </div>
        {/* ── Event Type & Attendees ── */}
        <div className="grid grid-cols-1 gap-4 my-4">
          <div>
            <Select
              fullWidth
              value={eventType}
              onChange={(e) => {
                setEventType(e.target.value);
                if (errors.eventType)
                  setErrors((prev) => ({ ...prev, eventType: "" }));
              }}
              error={Boolean(errors.eventType)}
              displayEmpty
              renderValue={(selected) =>
                selected ? (
                  selected
                ) : (
                  <span className="text-gray-400">
                    Event Type <span style={{ color: "red" }}>*</span>
                  </span>
                )
              }
            >
              <MenuItem value="Educational Event">Educational Event</MenuItem>
              <MenuItem value="Commercial & Marketing Events">
                Commercial & Marketing Events
              </MenuItem>
            </Select>
            {errors.eventType && (
              <p className="text-xs text-red-500 mt-1">{errors.eventType}</p>
            )}
          </div>
          <Select
            fullWidth
            value={attendeesFrom}
            onChange={(e) => setAttendeesFrom(e.target.value)}
            displayEmpty
            renderValue={(selected) =>
              selected ? (
                selected
              ) : (
                <span className="text-gray-400">Attendees From</span>
              )
            }
          >
            {engagementLocationScopes.map((loc) => (
              <MenuItem key={loc} value={loc}>
                {loc}
              </MenuItem>
            ))}
          </Select>
        </div>
        {/* ── Age Range ── */}
        <div className="grid grid-cols-2 gap-4 my-4">
          <TextField
            label="Minimum Age Range"
            type="number"
            value={minAge}
            inputProps={{ min: 0, step: 1 }}
            error={Boolean(errors.minAge)}
            helperText={errors.minAge || ""}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || Number(value) >= 0) setMinAge(value);
              if (errors.minAge) setErrors((prev) => ({ ...prev, minAge: "" }));
            }}
          />
          <TextField
            label="Maximum Age Range"
            type="number"
            value={maxAge}
            inputProps={{ min: 0, step: 1 }}
            error={Boolean(errors.maxAge)}
            helperText={errors.maxAge || ""}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || Number(value) >= 0) setMaxAge(value);
              if (errors.maxAge) setErrors((prev) => ({ ...prev, maxAge: "" }));
            }}
          />
        </div>
        {/* ── Admission Fee ── */}
        <div className="my-4">
          <Typography variant="subtitle1" className="font-bold">
            <span>
              Admission Fee: <span style={{ color: "red" }}>*</span>
            </span>
          </Typography>
          <RadioGroup
            row
            value={admissionFeeType}
            onChange={(e) => {
              const v = e.target.value;
              setAdmissionFeeType(v);
              if (v === "Free") setAdmissionFee("");
              if (errors.admissionFeeType)
                setErrors((prev) => ({ ...prev, admissionFeeType: "" }));
            }}
          >
            <FormControlLabel value="Free" control={<Radio />} label="Free" />
            <FormControlLabel value="Paid" control={<Radio />} label="Paid" />
          </RadioGroup>
          {errors.admissionFeeType && (
            <p className="text-xs text-red-500 mt-1">
              {errors.admissionFeeType}
            </p>
          )}
          {admissionFeeType === "Paid" && (
            <TextField
              fullWidth
              label="Admission Fee"
              value={admissionFee}
              error={Boolean(errors.admissionFee)}
              helperText={errors.admissionFee || ""}
              onChange={(e) => {
                setAdmissionFee(e.target.value);
                if (errors.admissionFee)
                  setErrors((prev) => ({ ...prev, admissionFee: "" }));
              }}
            />
          )}
        </div>
        <AddComCon
          open={true}
          groupId={groupId}
          hideCommunitySelector={true}
          isEditMode={isEditMode}
          originalGroupIds={originalGroupIds}
        />
        <div className="z-10 fixed bottom-0 left-0 w-full flex justify-center border-t bg-white">
          <div className="bg-white w-5/6 m-auto md:w-1/2 py-4 md:px-10 flex justify-end">
            <button
              type="submit"
              className={clsx(classes.button, "w-24 rounded-3xl p-2 px-6")}
            >
              {loading ? (
                <CircularProgress size={"20px"} color="inherit" />
              ) : (
                <Typography color={"white"}>
                  {editId ? "Update" : "Post"}
                </Typography>
              )}
            </button>
          </div>
        </div>
      </form>
    </Layout >
  );
};

export default CreateEvent;
